import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import LogoHeader from '../../components/common/logoHeader';
import Message from '../../components/common/largeText';

const Wrapper = styled.div``;

const MissingPermission = ({ t }) => (
  <Wrapper>
    <LogoHeader />
    <Message>{t('no_permission_to_replenish_device')}</Message>
  </Wrapper>
);

export default translate('common')(MissingPermission);
